module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-4.d291843c.png";